import React from "react"
import DataTable from "react-data-table-component"

import Loading from "./Loading"

const customStyles = {
  headCells: {
    style: {
      fontSize: "15px",
      fontWeight: "bold",
    },
  },
}


export default (props) => {

  return (
    <>
      <DataTable
        style={{ marginBottom: '0', paddingBottom: '0' }}
        overflowY={props.overflowY}
        columns={props.columns}
        data={props.data}
        pagination={props.pagination === false ? false : true}
        noHeader={true}
        customStyles={customStyles}
        progressPending={props.loading}
        fixedHeader
        fixedHeaderScrollHeight="550px"
        progressComponent={
          <Loading
            loading={props.loading}
            margin={"165px"}
            size={50}
            color={"black"}
          />
        }
        paginationComponentOptions={{
          rowsPerPageText: "Registros por página:",
          rangeSeparatorText: "de",
        }}
        paginationPerPage={props.paginationPerPage}
        paginationRowsPerPageOptions={
          props.notPerPage ? [5] : [5, 10, 15, 20, 25]
        }
      />
    </>
  )
}
